import React from "react"
import Link from "./link"
import { htmlDecode } from "../Utils"

const ThreeBlockIconTextGrid = ({
  key,
  image=false,
  imageLink=false,
  heading=false,
  content=false,
  iconWithTextBlockSetup=false,
  ctaButtonText=false,
  ctaButtonLink=false,
  iconTextBlocks=false
}) => {

  const cdnUrl = 'https://dlyog079eaher.cloudfront.net';

  return (
    <div className="three-block-icon-with-text-grid">
      <div className="container">
        <div className="col-12">
          {image &&
            <div className="img-container mb2 d-flex jcc aic">
              {imageLink &&
                <Link href={ imageLink } title={ imageLink }>
                  {image.formats.medium &&
                    <img src={image.formats.medium.url.includes(cdnUrl) ? image.formats.medium.url : cdnUrl + image.formats.medium.url} alt={ image?.alternativeText } />
                  }
                  {!image.formats.medium &&
                    <img src={image.url.includes(cdnUrl) ? image.url : cdnUrl + image.url} alt={ image?.alternativeText } />
                  }
                </Link>
              }
              {!imageLink &&
                <>
                  {image.formats.medium &&
                    <img src={image.formats.medium.url.includes(cdnUrl) ? image.formats.medium.url : cdnUrl + image.formats.medium.url} alt={ image?.alternativeText } />
                  }
                  {!image.formats.medium &&
                    <img src={image.url.includes(cdnUrl) ? image.url : cdnUrl + image.url} alt={ image?.alternativeText } />
                  }
                </>
              }
            </div>
          }
          <div className="col-xs-12 col-md-8 mx-auto">
            <div className="row jcc tac fww">
              {heading &&
                <h2 className={ `content-title center ${content ? "orange-dash mb0" : "mb4"}` }>{ htmlDecode(heading) }</h2>
              }
              {content &&
                <div className="section-content mb2" dangerouslySetInnerHTML={{ __html: content }} />
              }
            </div>
          </div>
          <div className={ `row jcsb d-flex flex-wrap block-wrap ${iconWithTextBlockSetup}-block-setup` }>
            {iconTextBlocks && iconTextBlocks.map((block) => (
              <div className="block-item col-12 col-lg-4 mv1">
                <div className="block-item-inner bgw col-12 jcfs">
                  <div className="img-container">
                    {block.icon.formats && block.icon.formats.small &&
                      <img src={block.icon.formats.small.url.includes(cdnUrl) ? block.icon.formats.small.url : cdnUrl + block.icon.formats.small.url} alt={ block.icon?.alternativeText } />
                    }
                    {!block.icon.formats?.small &&
                      <img src={block.icon.url.includes(cdnUrl) ? block.icon.url : cdnUrl + block.icon.url} alt={ block.icon?.alternativeText } />
                    }
                  </div>
                  <div className="block-item-text col pr0">
                    {block.title &&
                      <h2 className="three-block-title">{ htmlDecode(block.title) }</h2>
                    }
                    <div className="section-content" dangerouslySetInnerHTML={{ __html: block.content }} />
                  </div>
                </div>
              </div>
            ))}
          </div>
          {ctaButtonText && ctaButtonLink &&
            <div className="buttons col-12 tac mt3">
              <Link href={ ctaButtonLink } className="button inverse mh1">{ ctaButtonText }</Link>
            </div>
          }
        </div>
      </div>
    </div>
  )
}

export default ThreeBlockIconTextGrid
